import { BaseApi } from './base.api.js';

export class BigdesMeasureApi extends BaseApi {
    constructor(client) {
        super(client, '/bigdes-measure');
    }
}
